<div class="container margin">
  <form
    [formGroup]="providersForm"
    (ngSubmit)="
      providersForm.valid ? saveProvider(providersForm.value) : errorMessage()
    "
    >
    <div style="display: flex; width: 100%">
      <div style="flex: 10">
        <mat-tab-group>
          <mat-tab label="Informacion">
            <cdk-virtual-scroll-viewport
              itemSize="100"
              class="example-viewport"
              >
              <div class="first-row">
                <div class='row-item'>
                  <combos
                    [configuration]='combosProviderType'
                    [reloadCombo]='reloadComboProviderType'
                    [required]="true"
                    [filter]="true"
                    [control]="providersForm.get('providerType')"
                    [checkbox]="true"
                    >
                  </combos>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Nombre</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="providerName"
                      matInput
                      #nombre
                      maxlength="255"
                      placeholder="Nombre"
                      required
                      />
                    <mat-hint>{{ nombre.value.length }}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Enviar Correos</mat-label>
                    <mat-select formControlName="sendEmail">
                      <mat-option [value]="1">Si</mat-option>
                      <mat-option [value]="0">No</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              </div>

              <div class="default-row">

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Correo</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="email"
                      matInput
                      #correo
                      maxlength="255"
                      placeholder="Correo"
                      />
                    <mat-hint>{{ correo.value.length }}/255</mat-hint>
                    @if (providersForm.get('email')?.hasError('required')) {
                      <mat-error>
                        El correo es obligatorio
                      </mat-error>
                    }
                    @if (providersForm.get('email')?.hasError('email')) {
                      <mat-error>
                        Ingrese un correo válido
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Número identificación</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      matInput
                      formControlName="identificationNumber"
                      #identificacion
                      maxlength="255"
                      placeholder="Numero identificacion"
                      />
                    <mat-hint>{{ identificacion.value.length }}/255</mat-hint>
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Dirección</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="address"
                      matInput
                      #direccion
                      maxlength="255"
                      placeholder="Direccion"
                      />
                    <mat-hint>{{ direccion.value.length }}/255</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="default-row">

                <div class="row-item">
                  <combos
                    [configuration]="combosConfigCountry"
                    [reloadCombo]="reloadComboCountry"
                    (changeOption)="changesCountry($event)"
                    >
                  </combos>
                </div>

                <div class="row-item">
                  <combos
                    [configuration]="combosConfigRegion"
                    [reloadCombo]="reloadComboRegion"
                    [filter]="true"
                    (changeOption)="changesRegion($event)"
                    >
                  </combos>
                </div>

                <div class="row-item">
                  <combos
                    [configuration]="combosConfigCity"
                    [reloadCombo]="reloadComboCity"
                    [filter]="true"
                    (changeOption)="ValueIDCity($event)"
                    >
                  </combos>
                </div>
              </div>


              <div class="default-row">

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Encargado</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="manager"
                      matInput
                      #encargado
                      maxlength="255"
                      placeholder="Encargado"
                      />
                    <mat-hint>{{ encargado.value.length }}/255</mat-hint>
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Teléfono Encargado</mat-label>
                    <input
                      autocomplete="off"
                      type="number"
                      matInput
                      formControlName="managePhone"
                      #t_encargado
                      oninput="this.value = this.value.slice(0,30)"
                      placeholder="Teléfono Encargado"
                      />
                    <mat-hint>{{ t_encargado.value.length }}/30</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Teléfono empresa</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="companyPhone"
                      matInput
                      #t_empresa
                      oninput="this.value = this.value.slice(0,30)"
                      placeholder="Teléfono empresa"
                      />
                    <mat-hint>{{ t_empresa.value.length }}/30</mat-hint>
                  </mat-form-field>
                </div>

              </div>
              <div class="default-row">

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Descripción</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="description"
                      matInput
                      #descripcion
                      maxlength="1024"
                      placeholder="Descripción"
                      />
                    <mat-hint>{{ descripcion.value.length }}/1024</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div style="flex: 0.2">
        <button mat-mini-fab color="warn" type="submit">
          <mat-icon>save</mat-icon>
        </button>

        <!-- <button *ngIf='tipoRedireccion == "actualizar"' mat-mini-fab color="accent" style="margin-top: 10px;"
        (click)='eliminarTercero($event)'>
        <mat-icon>delete</mat-icon>
      </button> -->

      <button
        mat-mini-fab
        color="primary"
        (click)="back($event)"
        style="margin-top: 10px"
        >
        <mat-icon>reply</mat-icon>
      </button>
    </div>
  </div>
</form>
</div>
